<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h1>Manage Organisation Additional Charge Types</h1>
    </div>
    <div class="flex-shrink-1">
      <div class="pt-2">
        <button
          pButton
          type="button"
          label="Create"
          p-icon="fa fa-plus"
          class="ui-button ui-button-success btn-to-right pull-right"
          (click)="showSettingsFormDialog()"
        ></button>
      </div>
    </div>
  </div>
</div>
<div class="">
  <div class="content-container" style="position: relative">
    <form (ngSubmit)="search()" *ngIf="page.items">
      <div class="ui-g filterPanel">
        <div class="ui-g-12 ui-md-2 ui-lg-3">
          <div class="mt-2 pr-2">
            <organisation-select-list
              [minTextLength]="1"
              (valueChange)="onFilterOrganisationChange($event)"
            >
            </organisation-select-list>
          </div>
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1 pull-right">
          <button
            pButton
            type="submit"
            label="Search"
            class="ui-button btn-to-right"
            icon="fa fa-search"
            iconPos="right"
          ></button>
        </div>
      </div>
    </form>

    <p-table
      [value]="page.items"
      [sortField]="filterVal.sortField"
      [sortOrder]="filterVal.sortOrder"
      [paginator]="true"
      [pageLinks]="8"
      [totalRecords]="page.total"
      [lazy]="true"
      (onLazyLoad)="onGridLazyLoad($event)"
      [rows]="filterVal.rows"
      resizableColumns="true"
      [first]="filterVal.first"
      [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="">Organisation</th>
          <th class="">Org. Type</th>
          <th class="">Additional Charge Type</th>
          <th class="">Charge Customer</th>
          <th class="">Pay Supplier</th>
          <th class="">Charge Engineius Customer</th>
          <th class="">Pay Engineius Supplier</th>
          <th style="width: 6em"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr>
          <td styleClass="">
            <div class="">{{ rowData.organisationName }}</div>
          </td>
          <td class="text-center">
            <div class="">{{ rowData.organisationTypeName }}</div>
          </td>
          <td class="text-center">
            <div class="">{{ rowData.additionalChargeTypeName }}</div>
          </td>
          <td class="text-center">
            <span [ngClass]="rowData.chargeCustomer ? 'pi pi-check' : 'pi pi-times'"></span>
          </td>
          <td class="text-center">
            <span [ngClass]="rowData.chargeSupplier ? 'pi pi-check' : 'pi pi-times'"></span>
          </td>
          <td class="text-center">
            <span
              [ngClass]="rowData.chargeEngineiusCustomer ? 'pi pi-check' : 'pi pi-times'"
            ></span>
          </td>
          <td class="text-center">
            <span
              [ngClass]="rowData.chargeEngineiusSupplier ? 'pi pi-check' : 'pi pi-times'"
            ></span>
          </td>
          <td class="">
            <div class="ui-g-6">
              <span
                class="fa fa-pencil link"
                (click)="modifyOrgAdditionalChargeType(rowData)"
              ></span>
            </div>
            <div class="ui-g-6">
              <span
                class="fa fa-trash link text-danger"
                (click)="deleteOrgAdditionalChargeType(rowData)"
              ></span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-confirmDialog
      header="Confirmation"
      icon="fa-icon-circle"
      width="425"
      acceptLabel="Yes"
      rejectLabel="No"
    >
    </p-confirmDialog>

    <p-dialog
      #saveSettingsDialog
      [header]="
        settingsForm?.value?.id
          ? 'Update Org. Additional Charge Types Setting'
          : 'Create Org. Additional Charge Types Setting'
      "
      [(visible)]="isSettingsFormEnabled"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '650px' }"
    >
      <form
        (ngSubmit)="saveOrgAdditionalChargeType(settingsForm.value)"
        [formGroup]="settingsForm"
        *ngIf="isSettingsFormEnabled"
        autocomplete="off"
      >
        <div class="form-group ui-g-12">
          <div class="ui-grid-row">
            <div class="ui-g-4"><label for="organisation">Organisation</label></div>
            <div class="ui-g-8">
              <organisation-select-list
                [selectedOrganisationId]="selectedOrganisationId"
                [minTextLength]="1"
                [selectPlaceHolderText]="'Type to set organisation'"
                (valueChange)="onOrganisationChange($event)"
              ></organisation-select-list>
            </div>
            <div class="clearFix"></div>
            <div class="ui-g-4">
              <label for="additionalChargeTypeName">Additional Charge Type</label>
            </div>
            <div class="ui-g-8">
              <p-dropdown
                [options]="additionalChargeTypes"
                formControlName="additionalChargeTypeId"
                autoWidth="false"
                styleClass="form-component"
                tabindex="2"
              >
              </p-dropdown>
            </div>
            <div class="ui-g-6">
              <p-checkbox
                class="ui-g-12"
                id="chargeCustomer"
                formControlName="chargeCustomer"
                tabindex="3"
                [binary]="true"
                label="Charge Customer"
                (onChange)="handleChargeableEntityChange($event, 'isChargeCustomer')"
              ></p-checkbox>
            </div>
            <div class="ui-g-6">
              <p-checkbox
                class="ui-g-12"
                id="chargeSupplier"
                formControlName="chargeSupplier"
                tabindex="4"
                [binary]="true"
                label="Pay Supplier"
                (onChange)="handleChargeableEntityChange($event, 'isChargeSupplier')"
              ></p-checkbox>
            </div>
            <div class="ui-g-6">
              <p-checkbox
                class="ui-g-12"
                id="chargeEngineiusCustomer"
                formControlName="chargeEngineiusCustomer"
                tabindex="5"
                [binary]="true"
                label="Charge Engineius Customer"
                (onChange)="handleChargeableEntityChange($event, 'isChargeEngineiusCustomer')"
              ></p-checkbox>
            </div>
            <div class="ui-g-6">
              <p-checkbox
                class="ui-g-12"
                id="chargeEngineiusSupplier"
                formControlName="chargeEngineiusSupplier"
                tabindex="6"
                [binary]="true"
                label="Pay Engineius Supplier"
                (onChange)="handleChargeableEntityChange($event, 'isChargeEngineiusSupplier')"
              ></p-checkbox>
            </div>
          </div>
          <div class="ui-grid-row" style="float: right">
            <button
              type="button"
              class="ui-button-danger"
              pButton
              icon="pi pi-times"
              label="Cancel"
              (click)="isSettingsFormEnabled = false"
            ></button>
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="pi pi-check"
              [label]="settingsForm?.value?.id ? 'Update' : 'Add'"
              [disabled]="isSaving"
            ></button>
          </div>
        </div>
      </form>
    </p-dialog>
  </div>
</div>
